"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/divider/style/css");
var divider_1 = __importDefault(require("antd/lib/divider"));
require("antd/lib/descriptions/style/css");
var descriptions_1 = __importDefault(require("antd/lib/descriptions"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
require("antd/lib/modal/style/css");
var modal_1 = __importDefault(require("antd/lib/modal"));
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var utils_1 = require("../../utils");
var PageQR_1 = __importDefault(require("./PageQR"));
var HTMLContent_1 = __importDefault(require("../HTMLContent"));
var TGCPreviewHeader_1 = __importDefault(require("../TGCPreviewHeader"));
var TGCPreviewContent_1 = __importDefault(require("../TGCPreviewContent"));
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var styles = {
    revision: {
        marginTop: 16
    },
    content: {
        marginTop: 16
    }
};
var QRModal = /*#__PURE__*/ react_1.default.memo(function (_ref) {
    var qrModalOpen = _ref.qrModalOpen, hideQrModal = _ref.hideQrModal, page = _ref.page;
    return (0, jsx_runtime_1.jsx)(modal_1.default, {
        open: qrModalOpen,
        onCancel: hideQrModal,
        footer: null,
        children: (0, jsx_runtime_1.jsx)(PageQR_1.default, {
            page: page
        })
    });
});
var PagePreview = /*#__PURE__*/ react_1.default.memo(function (_ref2) {
    var _page$content;
    var page = _ref2.page;
    return (0, jsx_runtime_1.jsxs)("div", {
        className: "tgc-preview page-preview",
        children: [(0, jsx_runtime_1.jsx)(TGCPreviewHeader_1.default, {
                headerImage: page.header_image,
                longTitle: page.long_title,
                subtitle: page.subtitle
            }), (0, jsx_runtime_1.jsx)(TGCPreviewContent_1.default, {
                children: (0, jsx_runtime_1.jsx)(HTMLContent_1.default, {
                    id: "page-detail-content",
                    htmlContent: (_page$content = page === null || page === void 0 ? void 0 : page.content) !== null && _page$content !== void 0 ? _page$content : ""
                })
            })]
    });
});
var pageDetailTitle = (0, utils_1.detailTitle)("Page", "title");
var PageDetailView = /*#__PURE__*/ react_1.default.memo(function () {
    var _page$subtitle, _page$icon, _page$revision$number, _page$revision, _page$revision$messag, _page$revision2, _page$revision3;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _useParams = (0, react_router_dom_1.useParams)(), pageID = _useParams.id;
    var pagesInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.pages.initialFetchDone;
    });
    var pagesFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.pages.isFetching;
    });
    var page = (0, react_redux_1.useSelector)(function (state) {
        return (0, utils_1.findItemByID)(state.pages.items, pageID);
    });
    var _useState = (0, react_1.useState)(false), _useState2 = _slicedToArray(_useState, 2), qrModalOpen = _useState2[0], setQrModalOpen = _useState2[1];
    var onBack = (0, react_1.useCallback)(function () {
        return navigate(-1);
    }, [navigate]);
    var showQrModal = (0, react_1.useCallback)(function () {
        return setQrModalOpen(true);
    }, []);
    var hideQrModal = (0, react_1.useCallback)(function () {
        return setQrModalOpen(false);
    }, []);
    var editPage = (0, react_1.useCallback)(function () {
        return navigate("/pages/edit/".concat(pageID));
    }, [navigate, pageID]);
    var title = (0, react_1.useMemo)(function () {
        return pageDetailTitle(page, pagesInitialFetch, pagesFetching);
    }, [pagesInitialFetch, pagesFetching, page]);
    var extra = (0, react_1.useMemo)(function () {
        return [(0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.QrcodeOutlined, {}),
                onClick: showQrModal,
                disabled: !page,
                children: "QR Code"
            }, "qr"), (0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
                onClick: editPage,
                disabled: !page,
                children: "Edit"
            }, "edit")];
    }, [page, showQrModal, editPage]);
    return (0, jsx_runtime_1.jsxs)(page_header_1.default, {
        ghost: false,
        onBack: onBack,
        title: title,
        extra: extra,
        children: [(0, jsx_runtime_1.jsx)(QRModal, {
                qrModalOpen: qrModalOpen,
                hideQrModal: hideQrModal,
                page: page
            }), (0, jsx_runtime_1.jsxs)("div", {
                children: [(0, jsx_runtime_1.jsxs)(descriptions_1.default, {
                        bordered: true,
                        size: "small",
                        children: [(0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                                label: "Subtitle",
                                children: (_page$subtitle = page === null || page === void 0 ? void 0 : page.subtitle) !== null && _page$subtitle !== void 0 ? _page$subtitle : ""
                            }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                                label: "Menu Icon",
                                children: (_page$icon = page === null || page === void 0 ? void 0 : page.icon) !== null && _page$icon !== void 0 ? _page$icon : ""
                            }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                                label: "Enabled",
                                children: page !== null && page !== void 0 && page.enabled ? "Yes" : "No"
                            })]
                    }), (0, jsx_runtime_1.jsxs)(descriptions_1.default, {
                        bordered: true,
                        size: "small",
                        style: styles.revision,
                        children: [(0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                                label: "Revision",
                                span: 1,
                                children: (_page$revision$number = page === null || page === void 0 || (_page$revision = page.revision) === null || _page$revision === void 0 ? void 0 : _page$revision.number) !== null && _page$revision$number !== void 0 ? _page$revision$number : ""
                            }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                                label: "Update",
                                span: 1,
                                children: (_page$revision$messag = page === null || page === void 0 || (_page$revision2 = page.revision) === null || _page$revision2 === void 0 ? void 0 : _page$revision2.message) !== null && _page$revision$messag !== void 0 ? _page$revision$messag : ""
                            }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                                label: "Last Updated",
                                span: 1,
                                children: (0, utils_1.timestampToString)(page === null || page === void 0 || (_page$revision3 = page.revision) === null || _page$revision3 === void 0 ? void 0 : _page$revision3.timestamp)
                            })]
                    }), (0, jsx_runtime_1.jsx)(divider_1.default, {}), page && (0, jsx_runtime_1.jsx)(PagePreview, {
                        page: page
                    })]
            })]
    });
});
exports.default = PageDetailView;
